import Layout from "../components/Layout";
import SEO from "../components/SEO";

const chalantImages = [
  "/chalant/1.png",
  "/chalant/2.png",
  "/chalant/3.png",
  "/chalant/4.png",
  "/chalant/5.png",
  "/chalant/6.png",
  "/chalant/7.png",
  "/chalant/8.png",
  "/chalant/9.png",
];

const Chalant = () => {
  return (
    <Layout>
      <SEO
        title="Chalant"
        description="Chalant was a social media app for superfans that grew to over 1k users."
        type="website"
        url="/chalant"
        image="/ChalantLogo.png"
        imageAlt="Chalant"
        keywords={["Chalant", "Bekah June", "app", "superfans", "fan community", "social media"]}
      />

      <section className="px-4 sm:px-6 py-6 sm:py-10">
        <div className="w-full max-w-5xl mx-auto font-system text-[#000000]">
          <header className="mb-10 md:mt-6">
            <h1 className="text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[1.2] tracking-tight mb-3 text-[#000000]">
              Chalant
            </h1>
          </header>

          <p className="my-6 leading-[1.7] text-lg max-w-2xl">
            Chalant was a social media app for superfans that grew to over 1k users.
          </p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 items-start">
            {chalantImages.map((src, i) => (
              <img
                key={src}
                src={src}
                alt={`Chalant screenshot ${i + 1}`}
                className="w-full h-auto rounded-lg bg-[#000000]/5"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Chalant;
